/// <reference path="Game.ts"/>

import "p2";
import "pixi";
import "phaser";
import { Game } from "./Game";

window.onload = () => {

    let footchinko  = new Game();
};
